// Langue du TUTEUR : toujours le français.
//
// On LIT la table publique `LANGS` sans jamais la modifier : c'est un module de
// données pur (700 lignes pour cinq langues), le recopier créerait une dérive
// silencieuse le jour où un libellé change. Un import en lecture ne peut pas
// casser le parcours des autres — c'est une écriture qui le pourrait.
//
// Différence avec la version publique : `useLang()` y choisit la langue selon le
// DOMAINE. Ici l'espace personnel est monolingue : pas de contexte React, pas de
// détection, une constante.
import { LANGS } from '../lang';

export const lang = LANGS.fr;
export function useLang() {
  return lang;
}
